module.exports = __webpack_public_path__ + "static/media/ZLvsWalkmeChart-2.3716aa8f.svg";